"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileTypeIcons = void 0;
exports.getIconTypeByExtension = getIconTypeByExtension;
const fileTypeIcons = exports.fileTypeIcons = {
  access: ['mdb'],
  air: ['air'],
  audio: ['aa', 'aac', 'aax', 'aif', 'aiff', 'alac', 'au', 'flac', 'iff', 'm3u', 'm4a', 'm4p', 'mid', 'mogg', 'mp2', 'mp3', 'mpa', 'oga', 'ogg', 'ra', 'wav', 'wma'],
  cad: ['dwg'],
  code: ['aspx', 'bat', 'c', 'class', 'cpp', 'cs', 'css', 'cxx', 'exe', 'h', 'htm', 'html', 'hxx', 'java', 'js', 'jsx', 'ts', 'tsx', 'py', 'xml'],
  diskCatalogMaker: ['dcm'],
  email: ['eml', 'emlx', 'msg'],
  encapsulatedPostScript: ['eps', 'epsf', 'epsi'],
  excel: ['excel', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xlw'],
  csv: ['csv'],
  xltx: ['xltx'],
  flash: ['as', 'asc', 'fla', 'flash', 'jsfl', 'swf'],
  illustrator: ['ai'],
  image: ['bmp', 'exif', 'gif', 'jpeg', 'jpg', 'pdn', 'png', 'raw', 'svg', 'tif', 'tiff'],
  indesign: ['indb', 'indd', 'indl', 'indt', 'inx'],
  keynote: ['key'],
  rivet: ['rvt'],
  navisworks: ['nwd', 'nwf'],
  noteworthyComposer: ['nwc', 'nwctxt'],
  numbers: ['numbers'],
  onenote: ['one', 'onea', 'onetmp', 'onepkg'],
  onetoc: ['onetoc', 'onetoc2'],
  pages: ['pages'],
  pdf: ['pdf'],
  photoshop: ['psd', 'ps'],
  powerpoint: ['pot', 'potm', 'ppam', 'pps', 'ppt', 'pptm', 'pptx', 'sldm', 'sldx'],
  potx: ['potx'],
  ppsx: ['ppsx'],
  project: ['mpd', 'mpp', 'mpx'],
  mpt: ['mpt'],
  publisher: ['pub'],
  quickbooksBackup: ['qbb'],
  quickbooksWindows: ['qbw'],
  sketch: ['sketch'],
  text: ['log', 'rtf', 'text', 'txt', 'xml'],
  video: ['mov', 'mp4', 'm4v', 'wmv', 'mkv', 'avi', 'flv', '3gp', '3g2', 'mpg', 'webm'],
  visio: ['vdx', 'vsdm', 'vsd', 'vss', 'vst', 'vsx', 'vtx'],
  vssx: ['vssx'],
  vstx: ['vstx'],
  word: ['doc', 'docm', 'docx', 'dot', 'dotm', 'rtf'],
  dotx: ['dotx'],
  zip: ['7z', 'bz2', 'gz', 'rar', 'zip', 'zipx'],
  xsn: ['xsn'],
  vsdx: ['vsdx'],
  accdb: ['accdb']
};
function getIconTypeByExtension(extension) {
  const category = Object.keys(fileTypeIcons).find(key => {
    return fileTypeIcons[key].includes(extension);
  });
  return category;
}